// extracted by mini-css-extract-plugin
export var bg = "dentist-module--bg--nrbC0";
export var bgdesktop = "dentist-module--bgdesktop--prVsl";
export var bgtablet = "dentist-module--bgtablet--tNn-H";
export var bgxl = "dentist-module--bgxl--foGrd";
export var blurb = "dentist-module--blurb--FbMjq";
export var bottom = "dentist-module--bottom--pFy-D";
export var breadcrumbs = "dentist-module--breadcrumbs--hb+qF";
export var callout = "dentist-module--callout--WOSPX";
export var calloutleft = "dentist-module--calloutleft--sdIGa";
export var contentleft = "dentist-module--contentleft--LiUfw";
export var dentistcontainer = "dentist-module--dentistcontainer--z-2Wd";
export var dentistcontent = "dentist-module--dentistcontent--Brrgs";
export var dentistinfo = "dentist-module--dentistinfo--kXVeb";
export var desktopbreadcrumbs = "dentist-module--desktopbreadcrumbs---YceF";
export var gettoknow = "dentist-module--gettoknow--tkTxu";
export var heading = "dentist-module--heading--Q2EPA";
export var icon = "dentist-module--icon--O-+Bz";
export var image = "dentist-module--image--IQXP0";
export var insurance = "dentist-module--insurance--5uXYm";
export var insurancebottom = "dentist-module--insurancebottom--ptEhw";
export var insuranceimage = "dentist-module--insuranceimage--o0Hey";
export var left = "dentist-module--left--Ns+tL";
export var leftbottom = "dentist-module--leftbottom---9WzO";
export var lefttop = "dentist-module--lefttop--SKSR2";
export var link = "dentist-module--link--Rr71V";
export var linkhover = "dentist-module--linkhover--VhFnh";
export var list = "dentist-module--list--N-GpA";
export var listitem = "dentist-module--listitem--lcQVK";
export var locationlink = "dentist-module--locationlink--YgDF1";
export var locationname = "dentist-module--locationname--AZb0t";
export var loclink = "dentist-module--loclink--ejmtE";
export var logo = "dentist-module--logo--6nZZg";
export var logolink = "dentist-module--logolink--NQTyd";
export var mobilebreadcrumbs = "dentist-module--mobilebreadcrumbs--g-m1e";
export var right = "dentist-module--right--IkHTW";
export var screenreader = "dentist-module--screenreader--MCtfG";
export var specialties = "dentist-module--specialties--pUvEY";
export var title = "dentist-module--title--e31tc";
export var top = "dentist-module--top--FH3GY";